import { API_CONFIG, getApiUrl } from '../config/api';
import {
  SendOtpRequest,
  SendOtpResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
} from '../types/api';

export const sendOtp = async (msisdn: string): Promise<SendOtpResponse> => {
  const payload: SendOtpRequest = { msisdn };

  const response = await fetch(getApiUrl(API_CONFIG.endpoints.otpSend), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data: SendOtpResponse = await response.json();
  return data;
};

export const verifyOtp = async (
  msisdn: string,
  otp: string
): Promise<VerifyOtpResponse> => {
  const payload: VerifyOtpRequest = { msisdn, otp };

  const response = await fetch(getApiUrl(API_CONFIG.endpoints.otpVerify), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data: VerifyOtpResponse = await response.json();
  return data;
};
